export default [
    // *===================Tax Setup List============================---*

    {
        path: '/taxsetup/list',
        name: 'taxsetup-list',
        component: () => import('@/views/accounting/taxsetup/taxsetup-list/TaxSetup.vue'),
        meta: {
            pageTitle: 'Tax Setup List',
            breadcrumb: [
                {
                    text: 'Tax Setup List',
                    active: true,
                },
            ],
            //permission: 'Permissions.Accounting.View'            
        },
    },

]